import React, {useCallback, useMemo} from "react";
import {Popover, Select, Tabs} from "antd";
import {GameTarget, GameServer} from "src/typing";
import Picker, {ItemOptionType, TabItemOption} from "./Picker";
import {useQuery} from "react-query";
import {GameServerRole, RecentGameServer} from "../../../typing/game";
import {useMergedState} from "@firefly/fly-hook";
// import useMergedState from "../../../util/useMergedState";


export interface GameTargetPickerProps {

    username?: string;
    gameId?: string;
    value?: GameTarget | null;
    onChange?: (value: GameTarget | null) => void;

    serversFn: (gameId: string) => Promise<GameServer[]>;

    rolesFn?: (gameId: string, serverId: string, queryFn: () => Promise<GameServerRole[]>) => false | Promise<GameServerRole[]>;


}
const getJSONEx = (window as any).$.getJSONEx;
function GameTargetPicker(props: GameTargetPickerProps) {

    const {
        username,
        gameId,
        serversFn,
        rolesFn,
        value: _value,
        onChange
    } = props;

    const [value, setValue] = useMergedState<GameTarget | null>(null, {
        defaultValue: () => {
            return {
                gameId: gameId,
                serverId: undefined,
                roleId: undefined
            } as any
        },
        value: _value,
        onChange: onChange
    });
    const {
        data: servers,
    } = useQuery({
        queryKey: ["game", gameId, "servers"],
        enabled: !!gameId,
        queryFn: async () => {
            const value = await serversFn(gameId!)
            value.sort((a, b) => {
                return Number(b.serverId) - Number(a.serverId)
            })
            return value;
        }
    });

    const {
        data: recentServers,
    } = useQuery({
        queryKey: ["user", username, "game", gameId, "recent-servers"],
        enabled: !!gameId && !!username,
        queryFn: async () => {
            return new Promise<RecentGameServer[]>((resolve, reject) => {
                getJSONEx('//websvr.niu.niuxyx.com/userGameServerList.gameUserInfo?rtnName=?', {
                    'gameId': gameId,
                    'records':'10',
                    'username': username
                }, function(json: any){
                    if(json.rtn == 0){
                        let servers = json.data.data.map(function(server: any) {
                            return {
                                group: server.bigFenQuName,
                                name: server.fenqunickname,
                                no: server.gamearea,
                                serverId: server.serverid,
                            }
                        });
                        // servers = servers;
                        resolve(servers);
                    }
                });
            })
        }
    });


    const fetchRoles = useCallback((gameId: string, serverId: string) => {
        return new Promise<GameServerRole[]>((resolve, reject) => {
            getJSONEx('//paysvr.niu.niuxyx.com/gamepaycenter/getRole.role?rtnName=?', {
                'gameId': gameId,
                'serverid': serverId,
                'username': username
            }, function(json: any){
                if(json.code == "00"){
                    const roles: GameServerRole[] = [];
                    Object.keys(json.roleMap).forEach((key) => {
                        const v = json.roleMap[key];
                        roles.push({
                            roleId: key,
                            name: decodeURIComponent(v)
                        })
                    })
                    // servers = servers;
                    resolve(roles);
                    return;
                }
                reject();
            })
        })
            ;
    }, [])
    const {
        data: roles
    } = useQuery({
        queryKey: ["game", value?.gameId, "server", value?.serverId, 'roles'],
        enabled: !!value && !!value.gameId && !!value.serverId,
        queryFn: async () => {
            const gameId = value!.gameId;
            const serverId = value!.serverId;
            return await rolesFn?.(gameId, serverId, () => fetchRoles(gameId, serverId))
        }
    })



    const tabs = useMemo<TabItemOption[]>(() => {
        const tabs:TabItemOption[]  = [];
        if (servers) {
            if (recentServers && recentServers.length > 0) {
                const recentServiceIds = recentServers.map((item) => {
                    return item.serverId;
                })
                const recentGroup = servers.filter((server) => {
                    return !!~recentServiceIds.indexOf(server.serverId);
                })

                if (recentGroup.length > 0) {
                    tabs.push({
                        title: "最近玩过的",
                        options: recentGroup.map((server) => {
                            return {
                                value: server.serverId,
                                label: server.name,
                            }
                        })
                    });
                }
            }

            if (servers.length < 100) {
                tabs.push({
                    title: "区服",
                    options: servers.map((server) => {
                        return {
                            label: server.name,
                            value: server.serverId,
                        }
                    })
                })
            } else {
                const limit = 100;
                const groups: TabItemOption[] = [];
                let group: ItemOptionType[] = [];
                const endGroup = () => {
                    if (group.length > 0) {
                        if (group.length > limit) {
                            groups.push({
                                title: "其他",
                                options: group,
                            })
                        } else {
                            groups.push({
                                title: `${group[0].value} - ${group[group.length - 1].value}`,
                                options: group,
                            })
                        }
                    }
                }
                servers.forEach((value, item, index) => {
                    if (groups.length < 5 && group.length >= limit) {
                        endGroup();
                        group = [];
                    }
                    group.push({
                        label: value.name,
                        value: value.serverId
                    })
                }, [] as TabItemOption[])
                endGroup();

                tabs.push(...groups)
            }
        }
        return tabs;
    }, [recentServers, servers])

    return <div className={"game-target-picker"}>
        <Picker
            placeholder={"选择区服"}
            tabs={tabs}
            value={value?.serverId??null}
            onSelect={(v, item) => {
                setValue({
                    ...value!,
                    serverId: v as any,
                    serverName: item.label as any,
                })
            }}
        />
        {roles !== false && roles ?
            <Select<string, { value: string, label: string }>
                defaultValue="lucy"
                style={{ width: 120 }}
                onChange={(v, option) => {
                    setValue({
                        ...value!,
                        roleId: v!,
                        roleName: (option as any).label!
                    })
                }}
                options={roles.map((role) => {
                    return {
                        value: role.roleId,
                        label: role.name,
                    }
                })}
            />
        : null}


    </div>
}


export default GameTargetPicker;